const getBrowserOrigin = () =>
  typeof window !== "undefined" ? window.location.origin : "";

const trimTrailingSlash = (value = "") => String(value).replace(/\/+$/, "");
const trimSlashes = (value = "") => String(value).replace(/^\/+|\/+$/g, "");

const normalizeExternalUrl = (value = "") => {
  const trimmedValue = String(value || "").trim();
  if (!trimmedValue) {
    return "";
  }

  return /^https?:\/\//i.test(trimmedValue) ? trimmedValue : `https://${trimmedValue}`;
};

export const SITE_NAME = process.env.REACT_APP_SITE_NAME || "Paramount Today";

export const SITE_DESCRIPTION =
  process.env.REACT_APP_SITE_DESCRIPTION ||
  "Latest Hindi and English news updates from Paramount Today.";

export const SITE_URL = trimTrailingSlash(
  process.env.REACT_APP_PUBLIC_SITE_URL ||
    process.env.REACT_APP_SITE_URL ||
    getBrowserOrigin()
);

export const SHARE_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_SHARE_BASE_URL || ""
);

export const SHARE_ROUTE_PREFIX =
  process.env.REACT_APP_SHARE_ROUTE_PREFIX || "/news";

export const SITE_LOCALE = process.env.REACT_APP_SITE_LOCALE || "hi_IN";
export const SITE_LANGUAGE = process.env.REACT_APP_SITE_LANGUAGE || "hi";
export const SITE_TWITTER_HANDLE = process.env.REACT_APP_SITE_TWITTER_HANDLE || "";
export const SITE_LOGO_URL = process.env.REACT_APP_SITE_LOGO_URL || "";
export const DEFAULT_OG_IMAGE_URL =
  process.env.REACT_APP_DEFAULT_OG_IMAGE_URL || SITE_LOGO_URL || "";
export const GOOGLE_SITE_VERIFICATION =
  process.env.REACT_APP_GOOGLE_SITE_VERIFICATION || "";
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";
export const GTM_ID = process.env.REACT_APP_GTM_ID || "";

export const SOCIAL_LINKS = [
  {
    label: "X",
    href: normalizeExternalUrl(
      process.env.REACT_APP_X_URL ||
        process.env.REACT_APP_TWITTER_URL ||
        "https://x.com/ptnewsindia"
    ),
  },
  {
    label: "Facebook",
    href: normalizeExternalUrl(
      process.env.REACT_APP_FACEBOOK_URL ||
        "https://www.facebook.com/profile.php?id=61591790123784"
    ),
  },
  {
    label: "Instagram",
    href: normalizeExternalUrl(
      process.env.REACT_APP_INSTAGRAM_URL ||
        "https://www.instagram.com/paramounttodaynews/?hl=en"
    ),
  },
  {
    label: "YouTube",
    href: normalizeExternalUrl(
      process.env.REACT_APP_YOUTUBE_URL || "https://www.youtube.com/@ptnewslivemp"
    ),
  },
].filter((link) => Boolean(link.href));

export const getAbsoluteUrl = (value, base = SITE_URL) => {
  if (!value) {
    return "";
  }

  try {
    return new URL(value, base || getBrowserOrigin()).toString();
  } catch (error) {
    return value;
  }
};

export const getOptimizedImageUrl = (value) => {
  if (!value) {
    return "";
  }

  const imageUrl = String(value);
  if (!imageUrl.includes("res.cloudinary.com") || !imageUrl.includes("/upload/")) {
    return imageUrl;
  }

  if (imageUrl.includes("/upload/f_auto") || imageUrl.includes("/upload/q_auto")) {
    return imageUrl;
  }

  return imageUrl.replace("/upload/", "/upload/f_auto,q_auto/");
};

export const getNewsArticleUrl = (slug) => {
  if (!slug) {
    return SITE_URL;
  }

  return getAbsoluteUrl(`/${trimSlashes(slug)}`, SITE_URL);
};

export const getNewsShareUrl = (slug) => {
  if (!slug) {
    return SITE_URL;
  }

  if (!SHARE_BASE_URL) {
    return getNewsArticleUrl(slug);
  }

  return getAbsoluteUrl(
    `/${trimSlashes(SHARE_ROUTE_PREFIX)}/${trimSlashes(slug)}`,
    SHARE_BASE_URL
  );
};